import classnames from 'classnames';
import { func, number } from 'prop-types';
import React from 'react';
import { Col, Label, Row } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import CurrencyInput from '../../generic/CurrencyInput';
import { getProductMetaFieldName } from '../utils';

function renderCreativeBudgetLabel(label, name, index, width = 3, className) {
  return (
    <Label
      sm={width}
      for={getProductMetaFieldName(index, name)}
      className={classnames('c-campaign-line__label', className)}
    >
      {label}
    </Label>
  );
}

function renderCreativeBudgetValue(
  onChange,
  name,
  index,
  field,
  width = 3,
  plusSign = true,
) {
  return (
    <Col sm={width}>
      <CurrencyInput
        name={getProductMetaFieldName(index, name)}
        className="d-inline form-control p-0 pl-2 h-auto"
        value={field}
        style={{ width: '110px' }}
        onChange={onChange}
      />
      {plusSign && <span className="d-inline pl-4">+</span>}
    </Col>
  );
}

function CreativeLandingPageBudgetBreakdown({
  onChange,
  index,
  landingPageCost,
  mastercopyCost,
}) {
  return (
    <>
      <Row style={{ marginTop: '1rem' }}>
        <Col sm={3} />
        <Label sm={2} for="spendableBudget" className="c-campaign-line__label">
          Spendable Budget
        </Label>
        <Col sm={7}>
          <Row>
            {renderCreativeBudgetLabel(
              'Cost for landing page',
              'landingPageCost',
              index,
            )}
            {renderCreativeBudgetLabel(
              'Cost for mastercopy',
              'mastercopyCost',
              index,
            )}
          </Row>
        </Col>
      </Row>

      <Row className="align-items-baseline" style={{ marginTop: '-0.4rem' }}>
        <Col sm={3} />
        <Col sm={1}>
          <CurrencyFormat
            value={landingPageCost + mastercopyCost}
            name="spendableBudget"
            text
          />
        </Col>
        <Col sm={1} className="c-campaign-line__label pl-5">
          =
        </Col>
        <Col sm={7}>
          <Row>
            {renderCreativeBudgetValue(
              onChange,
              'landingPageCost',
              index,
              landingPageCost,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'mastercopyCost',
              index,
              mastercopyCost,
              3,
              false,
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
}

CreativeLandingPageBudgetBreakdown.propTypes = {
  index: number.isRequired,
  landingPageCost: number.isRequired,
  mastercopyCost: number.isRequired,
  onChange: func.isRequired,
};

export default CreativeLandingPageBudgetBreakdown;
